<p class="snack-bar__text">
  {{ text | translate }}
</p>
